var _path, _path2, _path3, _path4, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 205 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 5c0-1.6568 1.3431-3 3-3h158c7.732 0 14 6.268 14 14 0 7.732-6.268 14-14 14h-144c-9.3888 0-17-7.6112-17-17v-8z",
    fill: "url(#d)",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28 35h119.5c8.56 0 15.5 6.9396 15.5 15.5s-6.94 15.5-15.5 15.5h-119.5v-31z",
    fill: "url(#c)",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28 5c0-1.6568 1.3431-3 3-3h158c7.732 0 14 6.268 14 14v0c0 7.732-6.268 14-14 14h-144c-9.3888 0-17-7.6112-17-17v-8z",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29 39c0-1.6569 1.3431-3 3-3h117c7.732 0 14 6.268 14 14v0c0 7.732-6.268 14-14 14h-103c-9.3888 0-17-7.6112-17-17v-8z",
    stroke: "#6ED2FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 8,
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 44,
    r: 8,
    stroke: "#6ED2FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 113.7,
    x2: 113.7,
    y1: -4,
    y2: 31.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9379F6",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9379F6",
    stopOpacity: 0.03,
    offset: 0.89785
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 99.141,
    x2: 97.662,
    y1: 21.339,
    y2: 67.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED2FA",
    stopOpacity: 0.7,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED2FA",
    stopOpacity: 0.05,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 202.99,
    x2: 32.087,
    y1: 1.1064,
    y2: 51.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947AF5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E70FC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 19,
    x2: 2.0276,
    y1: 1.4894,
    y2: 2.2977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947AF5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E70FC",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardEditor);
export default __webpack_public_path__ + "static/media/card-editor.1c52ae0a23054515fac851b0644f5f57.svg";
export { ForwardRef as ReactComponent };